export const TABS = {
  FAVORITES_LIST: 'favorites-list',
  RECENT_PROFESSIONALS: 'recent-professionals',
  RECOMMENDED_PROS: 'new-to-you',
};

export const getInitialTab = (type) => {
  if (type === TABS.RECENT_PROFESSIONALS) return TABS.RECENT_PROFESSIONALS;
  if (type === TABS.RECOMMENDED_PROS) return TABS.RECOMMENDED_PROS;
  return TABS.FAVORITES_LIST;
};
